import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/logoStyle';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles(styles);

interface ILogoProps {
	size: 'sm' | 'rg' | 'lg';
	color: 'color' | 'black' | 'white';
	className?: string;
}

const Logo = ({ size, color, className }: ILogoProps) => {
	const classes = useStyles();

	const logoClasses = classNames({
		[classes.icon]: true,
		[classes[size]]: true,
		[`${className}`]: !!className,
	});

	return <img alt="logo" src={`/logo-${color}.svg`} className={logoClasses} />;
};

export default Logo;
